import { type RefObject, useLayoutEffect, useRef } from "react";

/**
 * A ref that always holds the value of the latest committed render — for a callback that must stay STABLE (a memoised
 * row's `onPick`, a warning cascade's confirm) yet act on what the screen shows now, not on the render it was made in.
 *
 * Read it inside the callback, never during render. It is written in a layout effect, so by the time any event or
 * awaited continuation reads it, it holds the committed value: a tap reaches it only after the render the user saw.
 */
export const useLatestRef = <T>(value: T): RefObject<T> => {
	const ref = useRef<T>(value);
	useLayoutEffect(() => {
		ref.current = value;
	}, [value]);
	return ref;
};
